import { Directive, effect, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ConfigService } from '../../core/services/config.service';
import { FeatureFlagsResponse } from '../../core/clients/portal/models';

@Directive({
  selector: '[appFeatureEnabled]',
})
export class FeatureEnabledDirective {
  private templateRef = inject(TemplateRef<HTMLElement>);
  private viewContainer = inject(ViewContainerRef);
  private configService = inject(ConfigService);

  appFeatureEnabled = input.required<keyof FeatureFlagsResponse>();
  appFeatureEnabledElse = input<TemplateRef<unknown> | null>(null);

  private currentTemplateRef: TemplateRef<unknown> | null = null;

  constructor() {
    effect(() => {
      const featureKey = this.appFeatureEnabled();
      const elseTemplate = this.appFeatureEnabledElse();
      const enabled = this.configService.isEnabled(featureKey);

      const targetTemplateRef = enabled ? this.templateRef : (elseTemplate ?? null);

      if (this.currentTemplateRef !== targetTemplateRef) {
        this.viewContainer.clear();
        this.currentTemplateRef = targetTemplateRef;
        if (targetTemplateRef) {
          this.viewContainer.createEmbeddedView(targetTemplateRef);
        }
      }
    });
  }
}
